import { IfpApplicationState } from '@shared/sec-loans'

export const validateEndStepState = (state: IfpApplicationState): void => {
  const isValidState: Record<IfpApplicationState, boolean> = {
    Accepted: true,
    Rejected: false,
    Cancelled: false,
    UnavailableOther: false,
    UnavailableDraftInvalidated: false,
    Draft: true,
    ReturnedByCoDebtor: true,
    Pending: true,
    Sending: true,
    WaitingForCoDebtor: true,
    WaitingForResend: true,
  }

  if (!isValidState[state]) {
    throw new Error('User has entered endstep with invalid state')
  }
}
